<div class="mss-modal__header">
    <div class="mmh__title">
        {{ page.title }}
    </div>
    <div class="mmh__close pointer" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
    </div>
</div>
<ion-content class="ion-content__modal">
    @for (block of page.content; track block) { @switch (block.type) { @case
    (Blocks.TEXT) {
    <app-block-text [item]="block"></app-block-text>
    } @case (Blocks.HIGHLIGHTS) {
    <app-block-highlight [item]="block"></app-block-highlight>
    } @case (Blocks.VIDEO) {
    <app-block-video [item]="block"></app-block-video>
    } @case (Blocks.CHAT) {
    <app-block-chat></app-block-chat>
    } } }

    <div class="fade-text"></div>
</ion-content>
